<template>
  <v-main>
    <section>
      <Title :title="title" :img="img"></Title>
    </section>
    <v-container class="mx-auto" style="max-width: 1100px;">
      <p>問い合わせ先：UI/UXグループ（ばんば、ラス）</p>
      <v-row no-gutters justify="center" align-content="center" class="mx-auto">
        <v-col>
          <v-data-table
              :headers="headers"
              hide-default-footer
              :items="uiUxFiles"
              group-by="category"
              :items-per-page="-1"
              disable-sort
          >
            <!-- アクション -->
            <template v-slot:item.actions="{item}" class="align-content-start">
              <v-row no-gutters justify="start">
                <v-btn
                    class="mr-4 font-weight-bold"
                    dark
                    small
                    color="primary"
                    min-width="120px"
                    @click="openWindowBy(item.url)"
                >
                  表示
                </v-btn>
                <v-btn
                    class="mr-4 font-weight-bold"
                    dark
                    small
                    color="blue"
                    min-width="120px"
                    @click="downloadFileBy(item.downloadUrl, item.filename)"
                    v-if="item.enableDownload === true"
                >
                  ダウンロード
                </v-btn>
              </v-row>
            </template>
            <template v-slot:group.header="{group, isOpen, toggle}">
              <td colspan="4" bgcolor="#E3F2FD">
                <v-btn @click="toggle" x-small icon :ref="group">
                  <v-icon v-if="isOpen">mdi-minus</v-icon>
                  <v-icon v-else>mdi-plus</v-icon>
                </v-btn>
                <span class="font-weight-bold">{{ group }}</span>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { Logger } from 'aws-amplify';
import { mapActions, mapGetters } from 'vuex';
import { FileCategory } from '@/store/actions';
import Title from '../components/Title';

const logger = new Logger('ui_ux');

export default {
  name: 'UiUxView',
  components: {
    Title,
  },
  created() {
    logger.info('created');
    this.getFilesByCategory(FileCategory.UIUX);
    logger.info('stateの中身', this.$store.state.files.uiUx);
  },
  data() {
    return {
      // 一覧のヘッダー
      headers: [
        {
          text: 'カテゴリー',
          align: 'center',
          value: 'category',
        },
        {
          text: 'ファイル名',
          align: 'left',
          value: 'filename',
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
        },
        {
          text: '最終更新',
          align: 'center',
          value: 'updatedAt',
        },
        {
          text: '更新者',
          align: 'center',
          value: 'contributor',
        },
      ],
      title: 'UI/UX',
      img: 'title_uiUx.svg',
    };
  },

  methods: {
    /**
     * URLを別タブで開く
     * @param url
     */
    openWindowBy(url) {
      logger.info('openUrl', url);
      window.open(url, '_blank');
    },

    /**
     * url指定してダウンロードする
     * @param url
     * @param filename
     */
    downloadFileBy(url, filename) {
      logger.info('downloadUrl', url);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
    },

    ...mapActions(['getFilesByCategory']),
  },

  computed: {
    ...mapGetters(['uiUxFiles']),
  },
};
</script>

<style scoped lang="scss">
</style>